import { DialogLocal } from "@/components/Dialog";
import { GetCancelsOrderDailyCount } from "@/types/Api/Market/Order/getCancelsOrderDailyCount";
export default {};
export const dialogConfirmDidNotRecived = (cb: Function) => {
  DialogLocal({
    title: "是否未收到转账",
    cancelText: "取消",
    content: <>
        请再次确认您的收款账户是否未收到转账， 如发现
        <span style={{
        color: "#FB2222"
      }}>恶意不确认转币</span>
        可能会面临
        <span style={{
        color: "#FB2222"
      }}>「永久封号」</span>
        处理
      </>,
    async onConfirm() {
      cb();
      return true;
    }
  });
};
export const dialogConfirmTrading = (cb: Function) => {
  DialogLocal({
    title: "是否开始交易",
    cancelText: "取消",
    content: <>开始交易后可在“交易记录”，“订单”中 「我的卖单」完成后续操作</>,
    async onConfirm() {
      cb();
      return true;
    }
  });
};
export const dialogConfirmCancelTradingSell = ({
  allowedCancelsOrderDailyCount,
  cancelsOrderDailyCount
}: GetCancelsOrderDailyCount["response"], cb: Function) => {
  DialogLocal({
    title: "是否取消该笔交易",
    cancelText: "取消",
    content: <div>
        <div style={{
        fontWeight: 600
      }}>提示：</div>
        <div>
          1.如果您在一天内取消
          <span style={{
          color: "#FB2222"
        }}>
            {allowedCancelsOrderDailyCount}次
          </span>
          买卖订单，当天您的账户将会被禁止买卖。
        </div>
        <div>2.如果因为您的收款账户异常，无法创建订单，请拒绝后联系在线客服为您暂停挂单</div>
        <div style={{
        textAlign: "center"
      }}>
          今日还可取消
          <span style={{
          color: "#FB2222"
        }}>
            {allowedCancelsOrderDailyCount - cancelsOrderDailyCount}次
          </span>
          订单，请谨慎操作
        </div>
      </div>,
    async onConfirm() {
      cb();
      return true;
    }
  });
};